import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import {
  Modal,
  MODAL_ANIMATION_TYPE,
  MODAL_CLOSE_BUTTON,
  MODAL_STYLE_TYPE,
  MODAL_TYPE,
} from 'b2b-components/theme/components/Modal';
import { useBarcodeAnalytics } from 'b2b-apps/core/analytics/context/barcode/BarcodeAnalyticsContext';
import { TEALIUM_PROD_ACTION } from 'b2b-apps/core/analytics/types/types';
import { isServer } from 'b2b-apps/shop/common/utils/env';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { useFetchProductTileByBarcodeEffect } from 'b2b-apps/shop/product/hooks';
import { ComponentType } from './index';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const CodeScannerModalComponent = !isServer ? require('./Component').CodeScannerModal : ((): null => null);

const CodeScannerModal: ComponentType = ({
  isOpen,
  onClose,
  className,
}) => {
  const [isCodeScannerReady, setIsCodeScannerReady] = useState(false);
  const {
    barcode,
    onScanBarcode,
    onScanBarcodeClear,
    productTile,
    barcodeSearch,
  } = useFetchProductTileByBarcodeEffect();
  const isProductNotFoundVisible = barcodeSearch.isLoaded && !barcodeSearch?.data?.length;
  const isLoadedProductVisible = barcodeSearch.isLoaded && productTile.isLoaded;
  const { analyzeBarcodeScan } = useBarcodeAnalytics();
  const t = useTranslate();

  const codeScannerModalClassName = classNames(
    'CodeScannerModal',
    {
      'CodeScannerModal--Ready': isCodeScannerReady,
    },
    className,
  );

  useEffect(() => {
    if (isOpen) {
      analyzeBarcodeScan(TEALIUM_PROD_ACTION.open);
    }
  }, [isOpen]);

  const handleCodeScannerReady = (): void => {
    !isCodeScannerReady && analyzeBarcodeScan(TEALIUM_PROD_ACTION.cameraSuccess);
    setIsCodeScannerReady(true);
  };

  const handleModalClose = () => {
    !isCodeScannerReady && analyzeBarcodeScan(TEALIUM_PROD_ACTION.cameraError);

    onClose();
  };

  return (
    <Modal
      animationType={MODAL_ANIMATION_TYPE.fade}
      className={codeScannerModalClassName}
      closeButton={MODAL_CLOSE_BUTTON.right}
      content={() => CodeScannerModal && (
        <CodeScannerModalComponent
          onClose={handleModalClose}
          onReady={handleCodeScannerReady}
          barcode={barcode}
          productTile={productTile}
          isProductNotFoundVisible={isProductNotFoundVisible}
          isLoadedProductVisible={isLoadedProductVisible}
          onScan={onScanBarcode}
          onScanClear={onScanBarcodeClear}
        />
      )
      }
      isOpen={isOpen}
      onCloseModal={handleModalClose}
      styleType={MODAL_STYLE_TYPE.transparent}
      text={{
        ariaLabel: t('Scan Code'),
        ariaCloseModal: t('Cancel'),
      }}
      type={MODAL_TYPE.fullscreen}
    />

  );
};

export { CodeScannerModal };
